var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"app-view list-view",style:({backgroundImage: _vm.bgGradient})},[_c('div',{staticClass:"jumbotron header"},[_c('h1',[_vm._v(_vm._s(_vm.title))])]),_c('VenueList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }